import {store} from '../../utilities'

export default function disabled() {
  const state = store.getState()
  return state.createValid
}
